import { getData } from "actions";
import { CardContainer, Container } from "components";
import {
  API_URL_department,
  API_URL_helpTopic,
  API_URL_report,
  baseurl,
} from "constants/api";
import useColorMode from "hooks/useColorMode";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import { useWindowSize } from "hooks/useWindowSize";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { AiOutlineCaretDown } from "react-icons/ai";
import { FaFileAlt, FaPlus, FaRandom, FaSync, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { departmentReducers } from "redux/departmentSlice";
import { helpTopicReducers } from "redux/helpTopicSlice";
import { reportReducers } from "redux/reportSlice";

const ReportHelpTopic = () => {
  const now = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(now.getMonth() - 1);
  const statusRef = useRef();
  const dispatch = useDispatch();
  const [colorMode, setColorMode] = useColorMode();
  const [department, setDepartment] = useState("");
  const [startdate, setStartdate] = useState(
    moment(oneMonthAgo).format("YYYY-MM-DD")
  );
  const [enddate, setEnddate] = useState(moment(now).format("YYYY-MM-DD"));
  const [isOpenStatus, setIsOpenStatus] = useState(false);
  const [created, setCreated] = useState(0);
  const [reopened, setReopened] = useState(0);
  const [closed, setClosed] = useState(0);
  const [duration, setDuration] = useState("daily");

  const {
    getDepartmentResult,
    getReportLoading,
    getReportResult,
  } = useSelector((state) => ({
    getDepartmentResult: state.department.getDepartmentResult,
    getReportResult: state.report.getReportResult,
    getReportLoading: state.report.getReportLoading,
  }));

  const getDepartment = useCallback(
    async (params) => {
      getData(
        API_URL_department,
        params,
        { dispatch, redux: departmentReducers },
        "GET_DEPARTMENT"
      );
    },
    [dispatch]
  );

  const getReport = useCallback(
    async (params) => {
      getData(
        API_URL_report,
        params,
        { dispatch, redux: reportReducers },
        "GET_REPORT"
      );
    },
    [dispatch]
  );

  const [value, setValue] = useState({
    startDate: oneMonthAgo,
    endDate: now,
  });

  const toggleDropdown = () => {
    if (isOpenStatus === false) {
      setIsOpenStatus(true);
    } else {
      setIsOpenStatus(true);
    }
  };

  useOnClickOutside(statusRef, () => {
    setIsOpenStatus(false);
  });

  const handleClick = (value) => {
    setDuration(value);
  };

  const submitFilter = (e) => {
    e.preventDefault();
    const params = `?startdate=${startdate}&enddate=${enddate}&department=${department}&created=${created}&closed=${closed}&reopened=${reopened}&duration=${duration}`;
    getReport(params);
  };

  const handlePDF = () => {
    const params = `?startdate=${startdate}&enddate=${enddate}&department=${department}&created=${created}&closed=${closed}&reopened=${reopened}&duration=${duration}`;

    // Buka URL di tab baru
    window.open(`${baseurl}/master/report/pdf${params}`, "_blank");
  };

  useEffect(() => {
    const params_department = `?limit=${9999999}`;
    const params_report = `?startdate=${startdate}&enddate=${enddate}&department=${department}&created=${created}&closed=${closed}&reopened=${reopened}&duration=${duration}`;
    getDepartment(params_department);
    getReport(params_report);
  }, [duration]);

  return (
    <Container>
      <CardContainer title={"Report Ticket Per Department"}>
        <div className="m-5 ">
          {/* filter  */}
          <a target=""></a>
          <form onSubmit={submitFilter}>
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="font-bold mb-1 inline-block">
                  Department
                </label>
                <select
                  id="department"
                  name="department"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                  className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  <option value="" className="font-bold">
                    Pilih
                  </option>
                  {getDepartmentResult.results &&
                    getDepartmentResult.results.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>
              <div>
                <label className="font-bold mb-1 inline-block">
                  Start date
                </label>
                <input
                  id="startdate"
                  name="stardate"
                  type="date"
                  value={startdate}
                  onChange={(e) => setStartdate(e.target.value)}
                  className="w-full p-0.5 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
              </div>
              <div>
                <label className="font-bold mb-1 inline-block">End date</label>
                <input
                  id="enddate"
                  name="enddate"
                  type="date"
                  value={enddate}
                  onChange={(e) => setEnddate(e.target.value)}
                  className="w-full p-0.5 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
              </div>
              <div className="flex items-start ">
                <div className="flex flex-col">
                  <label className="font-bold mb-1 inline-block">Status</label>
                  <div id="dibawah" className="relative inline-block flex-col">
                    <button
                      type="button"
                      className="inline-flex items-center px-4 py-1.5 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-black hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      onClick={toggleDropdown}
                    >
                      Select
                      <AiOutlineCaretDown
                        className="-mr-1 h-3 w-3 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>

                    {isOpenStatus && (
                      <div
                        ref={statusRef}
                        className="absolute z-10 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
                      >
                        <ul
                          className="py-1"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="options-menu"
                        >
                          <li className="inline-flex items-center p-1">
                            <input
                              id="createdtickets"
                              type="checkbox"
                              checked={created === 1}
                              onChange={(e) =>
                                setCreated(created === 1 ? 0 : 1)
                              }
                              className="mr-1"
                            />
                            Created Tickets
                          </li>
                          <li className="inline-flex items-center p-1">
                            <input
                              id="closedtickets"
                              type="checkbox"
                              className="mr-1"
                              checked={closed === 1}
                              onChange={(e) => setClosed(closed === 1 ? 0 : 1)}
                            />
                            Closed Tickets
                          </li>
                          <li className="inline-flex items-center p-1">
                            <input
                              id="reopenedtickets"
                              type="checkbox"
                              className="mr-1"
                              checked={reopened === 1}
                              onChange={(e) =>
                                setReopened(reopened === 1 ? 0 : 1)
                              }
                            />
                            Reopened Tickets
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                <button
                  type="submit"
                  className="mt-7 px-4 py-1.5 ml-4 border border-gray-300 rounded-md shadow-sm bg-sky-600 text-sm font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
          <div className="flex justify-between mb-4">
            <div>
              <button
                onClick={handlePDF}
                className="mt-3 px-2 py-1.5 rounded shadow-sm text-sm font-medium bg-sky-600 text-white hover:bg-sky-600"
              >
                Print PDF
              </button>
            </div>
          </div>

          {/* loading */}
          {getReportLoading && (
            <div>
              <div className="pt-10 pb-6 flex justify-center items-center">
                <SyncLoader color="#4477CE" />
              </div>
            </div>
          )}

          {getReportResult.data && (
            <>
              {/* Legend  */}
              <div className="flex gap-x-6 flex-wrap text-sm mb-4">
                <div className="flex items-center gap-2">
                  {getReportResult.data?.report[0].created !== undefined && (
                    <>
                      <div className="w-3 h-3 rounded-sm shadow bg-[#7dd3fc]"></div>

                      <div>Tickets Created</div>
                    </>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  {getReportResult.data?.report[0].reopened !== undefined && (
                    <>
                      <div className="w-3 h-3 rounded-sm shadow bg-[#34d399]"></div>
                      <div>Tickets Reopened</div>
                    </>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  {getReportResult.data?.report[0].closed !== undefined && (
                    <>
                      <div className="w-3 h-3 rounded-sm shadow bg-[#f87171]"></div>
                      <div>Tickets Closed</div>
                    </>
                  )}
                </div>
              </div>

              {/* Grafik  */}
              <div>
                <ResponsiveContainer width="100%" height={400}>
                  <AreaChart data={getReportResult.data?.report}>
                    <CartesianGrid strokeDasharray="1 0" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip
                      contentStyle={{
                        backgroundColor:
                          colorMode === "dark" ? "#111827" : "white",
                        border: 0,
                      }}
                    />
                    <Area
                      type="monotone"
                      dataKey="created"
                      stroke="#7dd3fc"
                      fill="url(#createdID)"
                    />
                    <Area
                      type="monotone"
                      dataKey="reopened"
                      stroke="#34d399"
                      fill="url(#reopenedID)"
                    />
                    <Area
                      type="monotone"
                      dataKey="closed"
                      stroke="#f87171"
                      fill="url(#closedID)"
                    />
                    <defs>
                      <linearGradient
                        id="createdID"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor="#7dd3fc"
                          stopOpacity={0.6}
                        />
                        <stop
                          offset="95%"
                          stopColor="#7dd3fc"
                          stopOpacity={0}
                        />
                      </linearGradient>
                      <linearGradient
                        id="reopenedID"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor="#34d399"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="#34d399"
                          stopOpacity={0}
                        />
                      </linearGradient>
                      <linearGradient id="closedID" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="#f87171"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="#f87171"
                          stopOpacity={0}
                        />
                      </linearGradient>
                    </defs>
                  </AreaChart>
                </ResponsiveContainer>
              </div>
              {/* Legend Total  */}
              <div className="grid grid-cols-12">
                <div className="col-span-12 md:col-span-3 flex flex-col justify-center items-center">
                  <div className="flex items-center text-yellow-500 gap-1 mb-1">
                    <FaFileAlt className="text-2xl" />
                    <FaRandom className="text-2xl" />
                    <p className="text-2xl">
                      {getReportResult.data &&
                        getReportResult.data?.current_progress}
                    </p>
                  </div>
                  <div className="text-center">CURRENT IN PROGRESS</div>
                </div>
                <div className="col-span-12 md:col-span-3 flex flex-col justify-center items-center">
                  <div className="flex items-center text-blue-500 gap-1 mb-1">
                    <FaFileAlt className="text-2xl" />
                    <FaPlus className="text-2xl" />
                    <p className="text-2xl">
                      {getReportResult.data &&
                        getReportResult.data?.ticket_created}
                    </p>
                  </div>
                  <div className="text-center">TOTAL CREATED</div>
                </div>
                <div className="col-span-12 md:col-span-3 flex flex-col justify-center items-center">
                  <div className="flex items-center text-yellow-500 gap-1 mb-1">
                    <FaFileAlt className="text-2xl" />
                    <FaSync className="text-2xl" />
                    <p className="text-2xl">
                      {getReportResult.data &&
                        getReportResult.data?.ticket_reopened}
                    </p>
                  </div>
                  <div className="text-center">TOTAL REOPENED</div>
                </div>
                <div className="col-span-12 md:col-span-3 flex flex-col justify-center items-center">
                  <div className="flex items-center text-green-500 gap-1 mb-1">
                    <FaFileAlt className="text-2xl" />
                    <FaTimes className="text-2xl" />
                    <p className="text-2xl">
                      {getReportResult.data &&
                        getReportResult.data?.ticket_closed}
                    </p>
                  </div>
                  <div className="text-center">TOTAL CLOSED</div>
                </div>
              </div>
            </>
          )}
        </div>
      </CardContainer>

      <div className="mt-4">
        <CardContainer title="Tabular">
          <div className="p-4">
            <table className="w-full">
              <thead>
                <tr className="border-b border-neutral-300 dark:border-neutral-700">
                  <th className="text-left p-2">Date</th>
                  {getReportResult.data?.report[0].created !== undefined && (
                    <>
                      <th className="text-left p-2">Created</th>
                    </>
                  )}
                  {getReportResult.data?.report[0].closed !== undefined && (
                    <>
                      <th className="text-left p-2">Closed</th>
                    </>
                  )}
                  {getReportResult.data?.report[0].reopened !== undefined && (
                    <>
                      <th className="text-left p-2">Reopenend</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {/* loading  */}
                {getReportLoading && (
                  <tr>
                    <td className="text-center py-12" colSpan={5}>
                      <div className="pt-10 pb-6 flex justify-center items-center">
                        <SyncLoader color="#4477CE" />
                      </div>
                    </td>
                  </tr>
                )}
                {/* Result  */}
                {getReportResult.data &&
                  getReportResult.data.report.map((item, index) => (
                    <tr
                      key={index}
                      className="border-b border-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-700 text-sm"
                    >
                      <td className="text-left p-2">
                        {moment(item.date_tabular).format("DD-MMMM-YYYY")}
                      </td>
                      {item.created !== undefined && (
                        <td className="text-left p-2">{item.created}</td>
                      )}
                      {item.closed !== undefined && (
                        <td className="text-left p-2">{item.closed}</td>
                      )}
                      {item.reopened !== undefined && (
                        <td className="text-left p-2">{item.reopened}</td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </CardContainer>
      </div>
    </Container>
  );
};

export default ReportHelpTopic;
